import React from "react";
import { useAppSelector } from "../../services/hooks";
import { aiQuotaSelector } from "../../services/selectors/entitlements.selectors";
import { IGetUserEntitlementsResponse } from "../../services/types/users.types";
import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./AiTokenUsage.module.css";

type AiScope = IGetUserEntitlementsResponse["aiQuota"]["company"];

const ScopeRow: React.FC<{ label: string; scope: AiScope }> = ({
  label,
  scope,
}) => {
  const used = scope.used.toLocaleString();
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {scope.limit === null
          ? t("AI_TOKEN_USED_UNLIMITED", { used })
          : t("AI_TOKEN_USED_OF", {
              used,
              limit: scope.limit.toLocaleString(),
            })}
      </span>
      {scope.walletBalance > 0 && (
        <span className={styles.purchased}>
          {t("AI_TOKEN_PURCHASED", {
            amount: scope.walletBalance.toLocaleString(),
          })}
        </span>
      )}
    </div>
  );
};

const AiTokenUsage: React.FC = () => {
  const aiQuota = useAppSelector(aiQuotaSelector);

  if (!aiQuota) return null;

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>{t("AI_TOKEN_USAGE_TITLE")}</h4>
      <ScopeRow label={t("AI_TOKEN_COMPANY")} scope={aiQuota.company} />
      <ScopeRow label={t("AI_TOKEN_USER")} scope={aiQuota.user} />
    </div>
  );
};

export default AiTokenUsage;
